<div class="container_selo " [ngClass]="{'on':selo.on,'off':selo.off}"  >
  <div class="icone selo" [inlineSVG]="'/assets/fidelidade/icones/icon-selo.svg'" [removeSVGAttributes]="['fill']"></div>
  <div class="valor"><span>{{selo.n}}</span></div>
</div>
